import { getSelectedProduct } from 'axp-product-ducks';
import { getProcedureResult } from 'iguazu-rpc';

import { READ_CUSTOMER_PRODUCTS_V2_FUNCTION } from '../constants';
import getBaseRoute from './getBaseRoute';
import { getDefaultProduct, getProduct, getTypeFromPath } from './productUtil';

const redirectToAccountDetails =
  (store) => async (nextState, replace, callback) => {
    const productsResult = getProcedureResult({
      procedureName: READ_CUSTOMER_PRODUCTS_V2_FUNCTION,
      args: {
        timeout: 6e3,
      },
    })(store.getState());

    let selectedProduct = getProduct(
      productsResult,
      await getSelectedProduct(store.getState())
    );

    if (selectedProduct === undefined) {
      selectedProduct = getDefaultProduct(
        productsResult,
        getTypeFromPath(nextState.location?.pathname)
      );
    }

    const route = getBaseRoute(selectedProduct?.type);

    replace(
      route.ACCOUNTS_DETAILS.replace(
        ':id',
        encodeURIComponent(selectedProduct?.opaqueAccountId)
      )
    );
    callback();
  };

export default redirectToAccountDetails;
